<template>
  <div class="device-attributes">
    <loader watch="device">
      <template v-if="hasAttributes">
        <ShowAttribute label="device" :value="deviceName(device)" />
        <b-row>
          <b-col>
            <ShowAttribute label="last seen" :value="formatLastSeen(device.updatedAt)" />
          </b-col>
          <b-col cols="12" xl="auto">
            <DeviceStatus
              :is-online="isDeviceOnline(device)"
              :switch-state="device.data && device.data.switchState"
              :device-name="device.deviceType"
            />
          </b-col>
        </b-row>
        <ShowAttribute label="modbus address" :value="device.modbusAddress" />
        <ShowAttribute label="active" :value="device.active" />
        <ShowAttribute label="alert" :value="device.alert" />
        <ShowAttribute label="firmware" :value="device.firmware" />
        <ShowAttribute label="serial number" :value="device.serial" />
        <ShowAttribute v-if="device.uptime" label="uptime" :value="uptime" />
      </template>
      <template v-else>
        <p>
          No data...
        </p>
      </template>
    </loader>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import HumanizeDuration from 'humanize-duration';
import DeviceMethods from '@/components/mixins/device-methods';
import ShowAttribute from '@/components/device/show-attribute';
import DeviceStatus from '@/components/device/device-status';

const SECOND_IN_MILLISECONDS = 1000; // 1s = 1000ms

const shortEnglishHumanizer = HumanizeDuration.humanizer({
  language: 'shortEn',
  spacer: '',
  units: ['y', 'mo', 'w', 'd', 'h', 'm', 's'],
  languages: {
    shortEn: {
      y: 'y',
      mo: 'mo',
      w: 'w',
      d: 'd',
      h: 'h',
      m: 'm',
      s: 's',
      ms: 'ms'
    }
  }
});

export default {
  name: 'DeviceAttributes',
  components: { ShowAttribute, DeviceStatus },
  mixins: [DeviceMethods],
  props: ['device'],
  computed: {
    hasAttributes() {
      return !isNil(this.device) && !isEmpty(this.device);
    },
    deviceStatus() {
      return this.isDeviceOnline(this.device) ? 'open' : 'closed';
    },
    uptime() {
      return shortEnglishHumanizer(this.device.uptime * SECOND_IN_MILLISECONDS);
    }
  }
};
</script>
